export default __webpack_public_path__ + "static/media/power.2844eee0.webp";